export default __webpack_public_path__ + "images/1c61af3d44a478319c1c03983c2a4896-menu-cat-outside.svg";